<div id="qr" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div>
                <img style="max-width: 35%;vertical-align: middle;padding-right: 20px;"
                    src="assets/images/logos/JITO Logo Round.png">
                <img style="max-width: 35%;vertical-align: middle;padding-right: 20px;"
                    src="assets/images/logos/jbn logo pagariya.jpeg">
            </div>

            <div class="title">Scan Qr</div>
            <img [src]="url">
        </div>

    </div>

</div>